import React from "react"

import styles from "./NoResultsForFilter.module.css"

import AddSection from "~/common/AddSection"
import Button from "~/common/buttons/Button"
import CalendarOutline from "~/common/calendar/CalendarOutline"
import { TangramPerson, TangramProject } from "~/common/react-icons"

import { userViewUpdate } from "~/mutations/User"

import { AvailableViewID } from "~/Views/ViewsProvider"

import PlannerGrid from "./PlannerGrid"

type Props = {
  subject: "projects" | "people"
  selectedView: AvailableViewID | null
}

const InvalidView = (props: Props) => {
  const { subject, selectedView } = props
  const message =
    selectedView === null ? (
      <>
        <div className={styles.heading}>
          You no longer have access to this view
        </div>
        <div className={styles.paragraph}>
          Contact an admin to be added to a view
        </div>
      </>
    ) : (
      <>
        <div className={styles.heading}>
          You no longer have access to this view
        </div>
        <div className={styles.paragraph}>
          Refresh the planner to load a permitted view.
        </div>
        <div className={styles.paragraph}>
          <Button
            onClick={() => {
              void userViewUpdate(selectedView)
            }}
          >
            Refresh
          </Button>
        </div>
      </>
    )
  return (
    <>
      <PlannerGrid>
        <div className={styles.container}>
          {subject === "projects" ? <TangramProject /> : <TangramPerson />}
          {message}
        </div>

        <div style={{ display: "flex" }}>
          <CalendarOutline type="standard" />
        </div>
      </PlannerGrid>
      <div style={{ flex: 1, display: "flex" }}>
        <AddSection />
      </div>
    </>
  )
}

export default InvalidView
